import styles from './styles.module.css'

export default function MethodsPaTool({dict}) {
    const {methods_pa_tool_1, methods_pa_tool_2} = dict.discover;
    return (
        <section className={styles.methods_pa_tool}>
            <p>{methods_pa_tool_1}</p>
            <p>{methods_pa_tool_2}</p>
        </section>
    );
}